// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4df704bb","513":"1a3cb342","703":"7cad7968","787":"3ce4cc4d"}[chunkId] + ".chunk.js";
};